// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2lfd2","footer":"ModalInfo_footer__1r5FC"};